/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import {
  Box, Tabs, Tab, Typography, Chip
} from '@mui/material';
import dayjs from 'dayjs';
import { useSnackbar } from 'notistack';
import * as hrAttendApi from '../../lib/api/hrAttend';
import * as approvalV2Api from '../../lib/api/approvalV2';
import { useSelector } from 'react-redux';
import AttendListTab from '../../components/attendancemng/AttendListTab';
import LeaveListTab from '../../components/attendancemng/LeaveListTab';
import LeaveRequestListTab from '../../components/attendancemng/LeaveRequestListTab';
import LeaveApprovalInboxTab from '../../components/attendancemng/LeaveApprovalInboxTab';
import WorkScheduleTab from '../../components/attendancemng/WorkScheduleTab';
import WorkScheduleRequestListTab from '../../components/attendancemng/WorkScheduleRequestListTab';
import AttendInputModal from '../../components/attendancemng/AttendInputModal';
import LeaveInputModal from '../../components/attendancemng/LeaveInputModal';
import LeaveRequestModal from '../../components/attendancemng/LeaveRequestModal';
import LeaveRequestActionDialog from '../../components/attendancemng/LeaveRequestActionDialog';
import LeaveRequestDetailDialog from '../../components/attendancemng/LeaveRequestDetailDialog';
import WorkScheduleChangeRequestDialog from '../../components/attendancemng/WorkScheduleChangeRequestDialog';
import BreadcrumbsContainer from '../common/breadcurmbs/BreadcrumbsContainer';
import { useLocation, useNavigate } from 'react-router-dom';

export const LEAVE_TYPE_LABELS = {
  ANNUAL: '유급 휴가',
  UNPAID: '무급 휴가',
  ABSENT: '무단 결근',
  EARLY_LEAVE: '조퇴',
  HALF_AM: '반차(오전)',
  HALF_PM: '반차(오후)',
  OVERTIME: '특근',
  BUSINESS: '출장',
  SICK: '병가',
};

export const LEAVE_TYPE_COLORS = {
  ANNUAL: 'success',
  UNPAID: 'warning',
  ABSENT: 'error',
  EARLY_LEAVE: 'warning',
  HALF_AM: 'info',
  HALF_PM: 'info',
  OVERTIME: 'secondary',
  BUSINESS: 'default',
  SICK: 'primary',
};

export const LEAVE_REQUEST_STATUS_LABELS = {
  IN_APPROVAL: '결재중',
  APPROVED: '승인완료',
  REJECTED: '반려',
  RECALLED: '회수',
  CANCELED: '취소',
};

export const LEAVE_REQUEST_STATUS_COLORS = {
  IN_APPROVAL: 'warning',
  APPROVED: 'success',
  REJECTED: 'error',
  RECALLED: 'default',
  CANCELED: 'default',
};

const AttendMngContainer = () => {
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useSelector(({ auth }) => ({ user: auth.user }));

  const [tabIndex, setTabIndex] = useState(0);
  const [searchYm, setSearchYm] = useState(dayjs().format('YYYYMM'));
  const [searchUsrUuid, setSearchUsrUuid] = useState('');

  const [attendList, setAttendList] = useState([]);
  const [workScheduleList, setWorkScheduleList] = useState([]);
  const [workScheduleRequestList, setWorkScheduleRequestList] = useState([]);
  const [workScheduleRequestInboxList, setWorkScheduleRequestInboxList] = useState([]);
  const [workShiftList, setWorkShiftList] = useState([]);
  const [holidayList, setHolidayList] = useState([]);
  const [leaveList, setLeaveList] = useState([]);
  const [leaveRequestList, setLeaveRequestList] = useState([]);
  const [approvalInboxList, setApprovalInboxList] = useState([]);
  const [approvalLineList, setApprovalLineList] = useState([]);

  const [attendLoading, setAttendLoading] = useState(false);
  const [workScheduleLoading, setWorkScheduleLoading] = useState(false);
  const [workScheduleSaving, setWorkScheduleSaving] = useState(false);
  const [workScheduleRequestLoading, setWorkScheduleRequestLoading] = useState(false);
  const [workScheduleRequestInboxLoading, setWorkScheduleRequestInboxLoading] = useState(false);
  const [workScheduleRequestSaving, setWorkScheduleRequestSaving] = useState(false);
  const [holidayLoading, setHolidayLoading] = useState(false);
  const [holidaySaving, setHolidaySaving] = useState(false);
  const [leaveLoading, setLeaveLoading] = useState(false);
  const [requestLoading, setRequestLoading] = useState(false);
  const [approvalLoading, setApprovalLoading] = useState(false);
  const [approvalLineLoading, setApprovalLineLoading] = useState(false);

  const [attendModalOpen, setAttendModalOpen] = useState(false);
  const [leaveModalOpen, setLeaveModalOpen] = useState(false);
  const [leaveRequestModalOpen, setLeaveRequestModalOpen] = useState(false);
  const [workScheduleRequestModalOpen, setWorkScheduleRequestModalOpen] = useState(false);
  const [selectedAttend, setSelectedAttend] = useState(null);
  const [selectedLeave, setSelectedLeave] = useState(null);
  const [selectedWorkSchedule, setSelectedWorkSchedule] = useState(null);
  const [actionDialog, setActionDialog] = useState({ open: false, mode: null, row: null });
  const [detailDialogOpen, setDetailDialogOpen] = useState(false);
  const [detailLoading, setDetailLoading] = useState(false);
  const [leaveRequestDetail, setLeaveRequestDetail] = useState(null);

  const [attendTick, setAttendTick] = useState(0);
  const [workScheduleTick, setWorkScheduleTick] = useState(0);
  const [workScheduleRequestTick, setWorkScheduleRequestTick] = useState(0);
  const [workScheduleRequestInboxTick, setWorkScheduleRequestInboxTick] = useState(0);
  const [leaveTick, setLeaveTick] = useState(0);
  const [requestTick, setRequestTick] = useState(0);
  const [approvalTick, setApprovalTick] = useState(0);

  useEffect(() => {
    const fetch = async () => {
      setAttendLoading(true);
      try {
        const res = await hrAttendApi.getAttendList({
          searchYm,
          searchUsrUuid: searchUsrUuid || undefined,
        });
        setAttendList(res.data.list || []);
      } catch (e) {
        enqueueSnackbar('출퇴근 목록 조회 실패', { variant: 'error' });
      } finally {
        setAttendLoading(false);
      }
    };
    fetch();
  }, [searchYm, searchUsrUuid, attendTick]);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await hrAttendApi.getWorkShifts();
        setWorkShiftList(res.data.list || []);
      } catch (e) {
        enqueueSnackbar('근무유형 조회 실패', { variant: 'error' });
      }
    };
    fetch();
  }, []);

  useEffect(() => {
    const fetch = async () => {
      setWorkScheduleLoading(true);
      try {
        const res = await hrAttendApi.getMyWorkSchedules({ workYm: searchYm });
        setWorkScheduleList(res.data.list || []);
      } catch (e) {
        enqueueSnackbar('내 근무표 조회 실패', { variant: 'error' });
      } finally {
        setWorkScheduleLoading(false);
      }
    };
    fetch();
  }, [searchYm, workScheduleTick]);

  useEffect(() => {
    const fetch = async () => {
      setWorkScheduleRequestLoading(true);
      try {
        const res = await hrAttendApi.getMyWorkScheduleRequests({ searchYm });
        setWorkScheduleRequestList(res.data.list || []);
      } catch (e) {
        enqueueSnackbar('근무표 변경 요청 조회 실패', { variant: 'error' });
      } finally {
        setWorkScheduleRequestLoading(false);
      }
    };
    fetch();
  }, [searchYm, workScheduleRequestTick]);

  useEffect(() => {
    const fetch = async () => {
      setWorkScheduleRequestInboxLoading(true);
      try {
        const res = await hrAttendApi.getWorkScheduleRequestInbox({ searchYm });
        setWorkScheduleRequestInboxList(res.data.list || []);
      } catch (e) {
        setWorkScheduleRequestInboxList([]);
      } finally {
        setWorkScheduleRequestInboxLoading(false);
      }
    };
    fetch();
  }, [searchYm, workScheduleRequestInboxTick]);

  useEffect(() => {
    const fetch = async () => {
      setHolidayLoading(true);
      try {
        const res = await hrAttendApi.getHolidays({ searchYm });
        setHolidayList(res.data.list || []);
      } catch (e) {
        setHolidayList([]);
      } finally {
        setHolidayLoading(false);
      }
    };
    fetch();
  }, [searchYm]);

  useEffect(() => {
    const fetch = async () => {
      setLeaveLoading(true);
      try {
        const res = await hrAttendApi.getLeaveList({
          searchYm,
          searchUsrUuid: searchUsrUuid || undefined,
        });
        setLeaveList(res.data.list || []);
      } catch (e) {
        enqueueSnackbar('휴가 목록 조회 실패', { variant: 'error' });
      } finally {
        setLeaveLoading(false);
      }
    };
    fetch();
  }, [searchYm, searchUsrUuid, leaveTick]);

  useEffect(() => {
    const fetch = async () => {
      setRequestLoading(true);
      try {
        const res = await hrAttendApi.getMyLeaveRequests({ searchYm });
        setLeaveRequestList(res.data.list || []);
      } catch (e) {
        enqueueSnackbar('휴가 신청 목록 조회 실패', { variant: 'error' });
      } finally {
        setRequestLoading(false);
      }
    };
    fetch();
  }, [searchYm, requestTick]);

  useEffect(() => {
    const fetch = async () => {
      setApprovalLoading(true);
      try {
        const res = await hrAttendApi.getLeaveApprovalInbox({ searchYm });
        setApprovalInboxList(res.data.list || []);
      } catch (e) {
        enqueueSnackbar('휴가 결재함 조회 실패', { variant: 'error' });
      } finally {
        setApprovalLoading(false);
      }
    };
    fetch();
  }, [searchYm, approvalTick]);

  useEffect(() => {
    if (!leaveRequestModalOpen) {
      return;
    }

    const fetch = async () => {
      setApprovalLineLoading(true);
      try {
        const res = await approvalV2Api.getApprovalV2Lines({ docType: 'HR_LEAVE' });
        setApprovalLineList(res.data.list || []);
      } catch (e) {
        enqueueSnackbar('v2 결재선 템플릿 조회 실패', { variant: 'error' });
      } finally {
        setApprovalLineLoading(false);
      }
    };
    fetch();
  }, [leaveRequestModalOpen]);

  const handleAttendSave = async (values) => {
    try {
      if (selectedAttend) {
        await hrAttendApi.editAttend(selectedAttend.attendUuid, values);
        enqueueSnackbar('출퇴근 정보를 수정했습니다.', { variant: 'success' });
      } else {
        await hrAttendApi.addAttend(values);
        enqueueSnackbar('출퇴근 정보를 등록했습니다.', { variant: 'success' });
      }
      setAttendModalOpen(false);
      setSelectedAttend(null);
      setAttendTick((t) => t + 1);
    } catch (e) {
      enqueueSnackbar('저장에 실패했습니다.', { variant: 'error' });
    }
  };

  const handleAttendDelete = async (attendUuid) => {
    try {
      await hrAttendApi.removeAttend(attendUuid);
      enqueueSnackbar('출퇴근 정보를 삭제했습니다.', { variant: 'success' });
      setAttendTick((t) => t + 1);
    } catch (e) {
      enqueueSnackbar('삭제에 실패했습니다.', { variant: 'error' });
    }
  };

  const handleWorkScheduleSave = async (schedules) => {
    setWorkScheduleSaving(true);
    try {
      const res = await hrAttendApi.saveMyWorkSchedules({
        workYm: searchYm,
        planStatus: 'CONFIRMED',
        schedules,
      });
      setWorkScheduleList(res.data.list || []);
      enqueueSnackbar('내 근무표를 저장했습니다.', { variant: 'success' });
      setWorkScheduleTick((t) => t + 1);
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || '근무표 저장에 실패했습니다.', { variant: 'error' });
    } finally {
      setWorkScheduleSaving(false);
    }
  };

  const handleWorkScheduleChangeRequestSubmit = async (values) => {
    setWorkScheduleRequestSaving(true);
    try {
      await hrAttendApi.submitWorkScheduleChangeRequest(values);
      setWorkScheduleRequestModalOpen(false);
      setSelectedWorkSchedule(null);
      setWorkScheduleTick((t) => t + 1);
      setWorkScheduleRequestTick((t) => t + 1);
      setWorkScheduleRequestInboxTick((t) => t + 1);
      enqueueSnackbar('근무표 변경 요청을 등록했습니다.', { variant: 'success' });
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || '근무표 변경 요청에 실패했습니다.', { variant: 'error' });
    } finally {
      setWorkScheduleRequestSaving(false);
    }
  };

  const handleWorkScheduleRequestCancel = async (row) => {
    if (!window.confirm('근무표 변경 요청을 취소할까요?')) return;
    setWorkScheduleRequestSaving(true);
    try {
      await hrAttendApi.cancelWorkScheduleChangeRequest(row.reqId);
      setWorkScheduleTick((t) => t + 1);
      setWorkScheduleRequestTick((t) => t + 1);
      setWorkScheduleRequestInboxTick((t) => t + 1);
      enqueueSnackbar('근무표 변경 요청을 취소했습니다.', { variant: 'success' });
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || '근무표 변경 요청 취소에 실패했습니다.', { variant: 'error' });
    } finally {
      setWorkScheduleRequestSaving(false);
    }
  };

  const handleWorkScheduleRequestConfirm = async (row) => {
    if (!window.confirm('근무표 변경 요청을 확정할까요?')) return;
    setWorkScheduleRequestSaving(true);
    try {
      await hrAttendApi.confirmWorkScheduleChangeRequest(row.reqId);
      setWorkScheduleTick((t) => t + 1);
      setWorkScheduleRequestTick((t) => t + 1);
      setWorkScheduleRequestInboxTick((t) => t + 1);
      enqueueSnackbar('근무표 변경 요청을 확정했습니다.', { variant: 'success' });
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || '근무표 변경 요청 확정에 실패했습니다.', { variant: 'error' });
    } finally {
      setWorkScheduleRequestSaving(false);
    }
  };

  const handleWorkScheduleRequestReject = async (row) => {
    if (!window.confirm('근무표 변경 요청을 반려할까요?')) return;
    setWorkScheduleRequestSaving(true);
    try {
      await hrAttendApi.rejectWorkScheduleChangeRequest(row.reqId);
      setWorkScheduleTick((t) => t + 1);
      setWorkScheduleRequestTick((t) => t + 1);
      setWorkScheduleRequestInboxTick((t) => t + 1);
      enqueueSnackbar('근무표 변경 요청을 반려했습니다.', { variant: 'success' });
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || '근무표 변경 요청 반려에 실패했습니다.', { variant: 'error' });
    } finally {
      setWorkScheduleRequestSaving(false);
    }
  };

  const handleHolidaySave = async (holiday) => {
    setHolidaySaving(true);
    try {
      const res = await hrAttendApi.saveHoliday({
        ...holiday,
        searchYm,
        holidayTyp: holiday.holidayTyp || 'COMPANY',
        sourceTyp: 'MANUAL',
        useYn: 'Y',
      });
      setHolidayList(res.data.list || []);
      enqueueSnackbar('휴일을 등록했습니다.', { variant: 'success' });
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || '휴일 등록에 실패했습니다.', { variant: 'error' });
    } finally {
      setHolidaySaving(false);
    }
  };

  const handleHolidayCollect = async () => {
    setHolidaySaving(true);
    try {
      const res = await hrAttendApi.collectHolidays({ searchYm });
      const insertedCount = res.data.insertedCount || 0;
      const updatedCount = res.data.updatedCount || 0;
      const skippedCount = res.data.skippedCount || 0;

      setHolidayList(res.data.list || []);
      setWorkScheduleTick((t) => t + 1);
      enqueueSnackbar(
        `국가공휴일 수집 완료: 신규 ${insertedCount}건, 갱신 ${updatedCount}건, 건너뜀 ${skippedCount}건`,
        { variant: 'success' },
      );
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || '국가공휴일 수집에 실패했습니다.', { variant: 'error' });
    } finally {
      setHolidaySaving(false);
    }
  };

  const handleLeaveSave = async (values) => {
    try {
      if (selectedLeave) {
        await hrAttendApi.editLeave(selectedLeave.leaveUuid, values);
        enqueueSnackbar('휴가 정보를 수정했습니다.', { variant: 'success' });
      } else {
        await hrAttendApi.addLeave(values);
        enqueueSnackbar('휴가 정보를 등록했습니다.', { variant: 'success' });
      }
      setLeaveModalOpen(false);
      setSelectedLeave(null);
      setLeaveTick((t) => t + 1);
    } catch (e) {
      enqueueSnackbar('저장에 실패했습니다.', { variant: 'error' });
    }
  };

  const handleLeaveDelete = async (leaveUuid) => {
    try {
      await hrAttendApi.removeLeave(leaveUuid);
      enqueueSnackbar('휴가 정보를 삭제했습니다.', { variant: 'success' });
      setLeaveTick((t) => t + 1);
    } catch (e) {
      enqueueSnackbar('삭제에 실패했습니다.', { variant: 'error' });
    }
  };

  const handleLeaveRequestSave = async (values) => {
    try {
      await hrAttendApi.submitLeaveRequest(values);
      enqueueSnackbar('휴가 신청을 상신했습니다.', { variant: 'success' });
      setLeaveRequestModalOpen(false);
      setRequestTick((t) => t + 1);
      setApprovalTick((t) => t + 1);
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || '휴가 신청 상신에 실패했습니다.', { variant: 'error' });
    }
  };

  const handleLeaveRequestRecall = async (leaveReqId) => {
    try {
      await hrAttendApi.recallLeaveRequest(leaveReqId);
      enqueueSnackbar('휴가 신청을 회수했습니다.', { variant: 'success' });
      setRequestTick((t) => t + 1);
      setApprovalTick((t) => t + 1);
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || '회수에 실패했습니다.', { variant: 'error' });
    }
  };

  const handleLeaveApprovalAction = async (comment) => {
    try {
      if (actionDialog.mode === 'APPROVE') {
        await hrAttendApi.approveLeaveRequest(actionDialog.row.leaveReqId, { rmk: comment });
        enqueueSnackbar('휴가 신청을 승인했습니다.', { variant: 'success' });
      } else {
        await hrAttendApi.rejectLeaveRequest(actionDialog.row.leaveReqId, { rmk: comment });
        enqueueSnackbar('휴가 신청을 반려했습니다.', { variant: 'success' });
      }
      setActionDialog({ open: false, mode: null, row: null });
      setApprovalTick((t) => t + 1);
      setRequestTick((t) => t + 1);
      setLeaveTick((t) => t + 1);
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || '결재 처리에 실패했습니다.', { variant: 'error' });
    }
  };

  const handleOpenLeaveRequestDetail = async (row) => {
    setDetailDialogOpen(true);
    setDetailLoading(true);
    try {
      const res = await hrAttendApi.getLeaveRequest(row.leaveReqId);
      setLeaveRequestDetail({
        info: res.data.info,
        steps: res.data.steps || [],
        actions: res.data.actions || [],
      });
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || '휴가 신청 상세 조회에 실패했습니다.', { variant: 'error' });
      setDetailDialogOpen(false);
      setLeaveRequestDetail(null);
    } finally {
      setDetailLoading(false);
    }
  };

  const handleCloseLeaveRequestDetail = () => {
    setDetailDialogOpen(false);
    setLeaveRequestDetail(null);

    if (location.search) {
      navigate(location.pathname, { replace: true });
    }
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const targetTab = searchParams.get('tab');
    const scope = searchParams.get('scope');
    const leaveReqId = searchParams.get('leaveReqId');
    const action = searchParams.get('action');

    if (targetTab === 'attend') {
      setTabIndex(0);
    } else if (targetTab === 'work') {
      setTabIndex(1);
    } else if (targetTab === 'work-requests') {
      setTabIndex(2);
    } else if (targetTab === 'work-inbox') {
      setTabIndex(3);
    } else if (targetTab === 'my') {
      setTabIndex(4);
    } else if (targetTab === 'inbox') {
      setTabIndex(5);
    }

    if (scope === 'me' && user?.usrUuid) {
      setSearchUsrUuid(user.usrUuid);
    } else if (scope === 'all') {
      setSearchUsrUuid('');
    }

    if (leaveReqId) {
      handleOpenLeaveRequestDetail({ leaveReqId });
    }

    if (targetTab === 'my' && action === 'request') {
      setLeaveRequestModalOpen(true);
      navigate(`${location.pathname}?tab=my`, { replace: true });
    }
  }, [location.search, user?.usrUuid]);

  return (
    <Box sx={{ p: 3 }}>
      <BreadcrumbsContainer title="환경설정/근태관리" />

      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1 }}>
        <Typography variant="h5" fontWeight={700}>근태 관리</Typography>
        <Chip
          label={`${searchYm.slice(0, 4)}년 ${parseInt(searchYm.slice(4), 10)}월`}
          size="small"
          color="primary"
          variant="outlined"
        />
      </Box>

      <Tabs value={tabIndex} onChange={(_, v) => setTabIndex(v)} sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}>
        <Tab label={`출퇴근 관리 (${attendList.length})`} />
        <Tab label={`내 근무표 (${workScheduleList.length})`} />
        <Tab label={`근무 변경 요청 (${workScheduleRequestList.length})`} />
        <Tab label={`근무 변경 승인 (${workScheduleRequestInboxList.length})`} />
        <Tab label={`내 휴가 신청 (${leaveRequestList.length})`} />
        <Tab label={`휴가 결재함 (${approvalInboxList.length})`} />
        <Tab label={`확정 휴가/근태 (${leaveList.length})`} />
      </Tabs>

      {tabIndex === 0 && (
        <AttendListTab
          list={attendList}
          loading={attendLoading}
          searchYm={searchYm}
          searchUsrUuid={searchUsrUuid}
          onSearchYmChange={setSearchYm}
          onSearchUsrChange={setSearchUsrUuid}
          onAdd={() => {
            setSelectedAttend(null);
            setAttendModalOpen(true);
          }}
          onEdit={(row) => {
            setSelectedAttend(row);
            setAttendModalOpen(true);
          }}
          onDelete={handleAttendDelete}
        />
      )}

      {tabIndex === 1 && (
        <WorkScheduleTab
          list={workScheduleList}
          shifts={workShiftList}
          holidays={holidayList}
          loading={workScheduleLoading || holidayLoading}
          saving={workScheduleSaving || holidaySaving}
          searchYm={searchYm}
          onSearchYmChange={setSearchYm}
          onSave={handleWorkScheduleSave}
          onHolidaySave={handleHolidaySave}
          onHolidayCollect={handleHolidayCollect}
          onChangeRequest={(row) => {
            setSelectedWorkSchedule(row);
            setWorkScheduleRequestModalOpen(true);
          }}
        />
      )}

      {tabIndex === 2 && (
        <WorkScheduleRequestListTab
          list={workScheduleRequestList}
          loading={workScheduleRequestLoading || workScheduleRequestSaving}
          searchYm={searchYm}
          mode="my"
          onSearchYmChange={setSearchYm}
          onCancel={handleWorkScheduleRequestCancel}
        />
      )}

      {tabIndex === 3 && (
        <WorkScheduleRequestListTab
          list={workScheduleRequestInboxList}
          loading={workScheduleRequestInboxLoading || workScheduleRequestSaving}
          searchYm={searchYm}
          mode="inbox"
          onSearchYmChange={setSearchYm}
          onConfirm={handleWorkScheduleRequestConfirm}
          onReject={handleWorkScheduleRequestReject}
        />
      )}

      {tabIndex === 4 && (
        <LeaveRequestListTab
          list={leaveRequestList}
          loading={requestLoading}
          searchYm={searchYm}
          onSearchYmChange={setSearchYm}
          onAdd={() => setLeaveRequestModalOpen(true)}
          onRecall={handleLeaveRequestRecall}
          onRowClick={handleOpenLeaveRequestDetail}
        />
      )}

      {tabIndex === 5 && (
        <LeaveApprovalInboxTab
          list={approvalInboxList}
          loading={approvalLoading}
          searchYm={searchYm}
          onSearchYmChange={setSearchYm}
          onApprove={(row) => setActionDialog({ open: true, mode: 'APPROVE', row })}
          onReject={(row) => setActionDialog({ open: true, mode: 'REJECT', row })}
          onRowClick={handleOpenLeaveRequestDetail}
        />
      )}

      {tabIndex === 6 && (
        <LeaveListTab
          list={leaveList}
          loading={leaveLoading}
          searchYm={searchYm}
          searchUsrUuid={searchUsrUuid}
          onSearchYmChange={setSearchYm}
          onSearchUsrChange={setSearchUsrUuid}
          onAdd={() => {
            setSelectedLeave(null);
            setLeaveModalOpen(true);
          }}
          onEdit={(row) => {
            setSelectedLeave(row);
            setLeaveModalOpen(true);
          }}
          onDelete={handleLeaveDelete}
        />
      )}

      <AttendInputModal
        open={attendModalOpen}
        data={selectedAttend}
        onClose={() => {
          setAttendModalOpen(false);
          setSelectedAttend(null);
        }}
        onSave={handleAttendSave}
      />

      <LeaveInputModal
        open={leaveModalOpen}
        data={selectedLeave}
        onClose={() => {
          setLeaveModalOpen(false);
          setSelectedLeave(null);
        }}
        onSave={handleLeaveSave}
      />

      <LeaveRequestModal
        open={leaveRequestModalOpen}
        onClose={() => setLeaveRequestModalOpen(false)}
        onSave={handleLeaveRequestSave}
        approvalLines={approvalLineList}
        approvalLineLoading={approvalLineLoading}
      />

      <WorkScheduleChangeRequestDialog
        open={workScheduleRequestModalOpen}
        row={selectedWorkSchedule}
        shifts={workShiftList}
        saving={workScheduleRequestSaving}
        onClose={() => {
          setWorkScheduleRequestModalOpen(false);
          setSelectedWorkSchedule(null);
        }}
        onSubmit={handleWorkScheduleChangeRequestSubmit}
      />

      <LeaveRequestActionDialog
        open={actionDialog.open}
        mode={actionDialog.mode}
        row={actionDialog.row}
        onClose={() => setActionDialog({ open: false, mode: null, row: null })}
        onConfirm={handleLeaveApprovalAction}
      />

      <LeaveRequestDetailDialog
        open={detailDialogOpen}
        loading={detailLoading}
        detail={leaveRequestDetail}
        onClose={handleCloseLeaveRequestDetail}
      />
    </Box>
  );
};

export default AttendMngContainer;
